export default __webpack_public_path__ + "ec4e78dca24ce1aadfe77961654a13e7.png";